import {
    CADASTRO_MENSAGENS_GET_MENSAGENS,
    CADASTRO_MENSAGENS_UPD_MENSAGEM
    
} from '../actions';

export default function cadastroMensagensReducer(state = null, action){
    switch(action.type){
        case CADASTRO_MENSAGENS_GET_MENSAGENS: // Preenchendo os dados
            return action.data
        case CADASTRO_MENSAGENS_UPD_MENSAGEM: // Para atualizar mensagem
            return (()=>{
                const copia = state.filter(ele=> String(ele.id) !== String(action.data.id) );
                // Atualiza a mensagem
                copia.push(action.data);
                
                return copia;
            })();
        default:
            return state;
    }
}